import api from "../libs/api";

export default {
  getAllLookups: (page, itemsPerPage, lookup) => {
    return new Promise((resolve, reject) => {
      const params = { page, itemsPerPage, lookup };
      api()
        .get("/lookups", { params })
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject(`Failed with status: ${status}`);
        })
        .catch(reject);
    });
  },

  getLookup: (lookup) => {
    return new Promise((resolve, reject) => {
      api()
        .get("/lookups", { params: { lookup } })
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject(`Failed with status: ${status}`);
        })
        .catch(reject);
    });
  },

  saveLookup: (data) => {
    return new Promise((resolve, reject) => {
      api()
        .post("/lookups", data)
        .then(({ status, data }) => {
          if (status === 200 || status === 201) resolve(data);
          else reject(new Error(`Unexpected response status: ${status}`));
        })
        .catch((error) => {
          const message =
            error.response?.data?.message ||
            error.message ||
            "Failed to save lookup";
          console.error("saveLookup error:", message);
          reject(new Error(message));
        });
    });
  },

  updateLookup: (id, data) => {
    return new Promise((resolve, reject) => {
      api()
        .put(`/lookups/${id}`, data)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject(new Error(`Unexpected response status: ${status}`));
        })
        .catch((error) => {
          const message =
            error.response?.data?.message ||
            error.message ||
            "Failed to update lookup";
          console.error("updateLookup error:", message);
          reject(new Error(message));
        });
    });
  },

  deleteLookup: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`/lookups/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject(`Failed with status: ${status}`);
        })
        .catch(reject);
    });
  },
};
